import Vue from 'vue';
import Component from 'vue-class-component';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { USER_REQUESTS_ROUTES } from '../../user-requests.router';
import { UserRequestsService } from '../../services/user-requests.service';
import { STATUS_ACTION_TYPES } from '../../values/user-requests.values';
import { STATUS_TYPES } from '../../values/user-requests.values'
import EdDenyUserRequestComponent from '../../components/ed-deny-user-request/ed-deny-user-request.component.vue';

@Component({
  components: {
    EdDenyUserRequestComponent
  }
})
export default class UserDetailsView extends Vue {

  /* Data */
  public request: any = null;
  public saving: boolean = false;
  public status: any = STATUS_TYPES;

  /* Methods */
  goBack() {
    this.$router.push({name: USER_REQUESTS_ROUTES.USER_REQUESTS.NAME });
  }

  denyUser() {
    this.$EdModal.createModal(EdDenyUserRequestComponent, { userIds: [this.request.id] });
  }

  approveUser() {
    this.$EdModal.createConfirmationModal(
      {
        body: this.$t('userRequests.info.approveUserConfirm'), 
        action: async () => {
          await this.approveUserConfirm();
        }
      }
    );
  }

  async approveUserConfirm() {
    this.saving = true;
    try { 
      await this.$UserRequests.Services.respondUserRequest({
        requestId: [this.request.id], 
        action: STATUS_ACTION_TYPES.APPROVE, 
        rejectionNote: ''
      })
      this.$EdToast.create({ 
        msg: `${this.$t('userRequests.success.userApproved')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this.saving = false;
      this.goBack()
    } catch {
      this.$EdToast.create({ 
        msg: `${this.$t('userRequests.success.userNoApproved')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.saving = false;
    }
  }

  async getUserRequest () {
    try { 
      this.request = await this.$UserRequests.Services.getUserRequest(Number(this.$route.query.requestId)) 
    } catch {
      this.$EdToast.create({ 
        msg:  `${this.$t('userRequests.errors.couldNotFindUser')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.goBack()
    }
  }

  /* Hooks */
  created() {
    this.getUserRequest()
  }

}